import { render, staticRenderFns } from "./barrage.vue?vue&type=template&id=5210b571&"
import script from "./barrage.vue?vue&type=script&lang=js&"
export * from "./barrage.vue?vue&type=script&lang=js&"
import style0 from "./barrage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports